import Vue from "vue";
import Router from "vue-router";

import Bizpro from "./views/Bizpro";
import Web from "./views/Web";
import GraphicDesign from "./views/GraphicDesign";
import Hosting from "./views/Hosting";
import ELearning from "./views/ELearning";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "bizpro",
      component: Bizpro,
    },
    {
      path: "/web",
      name: "web",
      component: Web,
    },
    {
      path: "/graphic-design",
      name: "GraphicDesign",
      component: GraphicDesign,
    },
    {
      path: "/hosting",
      name: "Hosting",
      component: Hosting,
    },
    {
      path: "/e-learning",
      name: "ELearning",
      component: ELearning,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
